/* eslint @typescript-eslint/naming-convention: 0 */

import type { WabunkaExperienceViewModel } from '@/models/wabunka/wabunkaExperience';
import { buildEventParams, type EventParams } from '@/wabunka-src/common/utils/googleAnalytics/common/event';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';
import type { WabunkaExperienceEventViewModel } from '@/wabunka-src/features/Experience/models/experienceEvent';

export interface ViewEventListParams {
  item_id: string;
  item_name: string;
  date: string;
  events: EventParams[];
}

const buildViewEventListParams = (experience: WabunkaExperienceViewModel, events: WabunkaExperienceEventViewModel[], date: string): ViewEventListParams => {
  return {
    item_id: experience.id,
    item_name: experience.name,
    date: date,
    events: events?.map((event) => buildEventParams(event)),
  };
};

/**
 * 発火タイミング：体験詳細のカレンダーにて日付を選択した時
 */
export const sendGAWabunkaViewEventListEvent = (experience: WabunkaExperienceViewModel, events: WabunkaExperienceEventViewModel[], date: string) => {
  sendWabunkaGAEvent('view_event_list', buildViewEventListParams(experience, events, date));
};
